import moment from "moment";

export default startDate => {
  const now = startDate || new Date();
  return [
    moment(now)
      .second(0)
      .millisecond(0)
      .toDate(),

    moment(now)
      .second(0)
      .millisecond(0)
      .add(120, "m")
      .toDate(),
  ];
};
